import { render } from "./TransactionCreate.vue?vue&type=template&id=ca3ab0d4"
import script from "./TransactionCreate.vue?vue&type=script&lang=js"
export * from "./TransactionCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__